export default __webpack_public_path__ + "static/media/lettremission.cf1ea083.png";